export { default } from './Backdrop';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Backdrop/index.js
// module id = 367
// module chunks = 121